import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const APPEAL_RECOMMENDATION_TEMPLATE_DETAILS_HELP: HelpContent[] = [
    {
        helpContentId: 'appeal-recommendation-template-details.template-exists',
        tooltipText: 'Template name already exists'
    }
];
